import { MessageDialogComponent } from './shared/features/message-dialog/components/message-dialog.component';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { NavMenuComponent } from "./shared/features/nav-menu/components/nav-menu.component";
import { HomeComponent } from './home/home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PageNotFoundComponent } from './shared/features/page-not-found/components/page-not-found.component';
import { LoginPageComponent } from './authmanagement/page/login/loginPage.component';
import { AuthInterceptorService } from './authmanagement/services/Auth-interceptor.service';
import { ConfigurationsPageComponent } from './dashboard-admin/page/configurationsPage.component';
import { MaterialModule } from '../material.module';
import { TableListComponent } from './shared/features/table/components/table-list/table-list.component';
import { SearchComponent } from './shared/features/table/components/search/search.component';
import { TableFiltersComponent } from './shared/features/table/components/table-filters/table-filters.component';
import { LoadingComponent } from './shared/features/loading/components/loading.component';
import { TooltipComponent } from './shared/features/tooltip/components/tooltip.component';
import { DashboardPageComponent } from './dashboard/page/dashboardPage.component';
import { RouteMapComponent } from './routeMap/components/route-map/route-map.component';
import { RouteFilterComponent } from './routeMap/components/route-filter/route-filter.component';
import { MapComponent } from './locations-map/components/map/map/map.component';
import { PanelLocationsComponent } from './locations-map/components/panel-locations/panel-locations.component';
import { PanelInternalLayersComponent } from './locations-map/components/panel-internal-layers/panel-internal-layers/panel-internal-layers.component';
import { PinBarComponent } from './locations-map/components/pin-bar/pin-bar.component';
import { LocationsMapComponent } from './locations-map/components/locations-map/locations-map.component';
import { CommonModule } from '@angular/common';
import { BrowserModule, DomSanitizer } from "@angular/platform-browser";
import { JwtHelperService, JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';
import { FilterPipe } from './routeMap/components/route-filter/pipes/filter.pipe';
import { LogoutComponent } from './authmanagement/components/logout/logout.component';
import { SignalRService } from './shared/services/Signal-R.service';
import { BasemapSelectorComponent } from './locations-map/components/basemap-selector/basemap-selector.component';
import { PanelDetailLocationsComponent } from './locations-map/components/panel-detail-locations/main-details-panel/panel-detail-locations.component';
import { PanelResumeRouteComponent } from './routeMap/components/panel-resume-route/panel-resume-route.component';
import { PanelDetailRouteStepsComponent } from './routeMap/components/panel-detail-routeSteps/panel-detail-routeSteps.component';
import { GeofencesMapComponent } from './geofences-map/components/geofences-map/geofences-map.component';
import { PanelGeofencesComponent } from './geofences-map/components/panel-geofences/panel-geofences.component';
import { TableauReportComponent } from './dashboard/components/tableau-report/tableau-report.component';
import { PanelDetailGeofencesComponent } from './geofences-map/components/panel-detail-geofences/panel-detail-geofences.component';
import { NavHeaderComponent } from './shared/features/header/components/nav-header.component';
import { TableauModule } from 'ngx-tableau'; 
import { ToastrModule } from 'ngx-toastr';
import { FilterMapComponent } from './locations-map/components/filters-map/filter-map.component';
import { ConfirmDialogComponent } from './shared/features/confirm-dialog/components/confirm-dialog.component';
import { ReportListComponent } from './shared/features/report-list/components/report-list.component';
import { FilterMapAutocompleteComponent } from './locations-map/components/filter-map-autocomplete/filter-map-autocomplete.component';
import { Map2Component } from './routeMap/components/map/map/map2.component';
import { UserPageComponent } from './users/pages/userPage/userPage.component';
import { UsersListComponent } from './users/components/users-list/users-list.component';
import { UsersUpdateComponent } from './users/components/users-update/users-update.component';
import { PopupReportHistorialComponent } from './locations-map/components/popup-report-historial/popup-report-historial.component';
import { Map3Component } from './geofences-map/components/map/map3.component';
import { RecoveryPasswordDialogComponent } from './authmanagement/dialog/recovery-password-dialog/recovery-password-dialog.component';
import { RecoveryPasswordPageComponent } from './authmanagement/page/recovery-password/recovery-passwordPage.component';
import { SendRecoveryPasswordDialogComponent } from './authmanagement/dialog/send-recovery-password-dialog/send-recovery-password-dialog.component';
import { EmailSendDialogComponent } from './authmanagement/dialog/email-send-dialog/email-send-dialog.component';
import { AdminVinControlComponent } from './users/components/admin-vin-control/admin-vin-control.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { GenericTableComponent } from './shared/features/generic-table/components/generic-table.component';
import { MapHelperService } from '../../services/map-helper.service';
import { ToolCarsSelectorComponent } from './locations-map/components/tools/tool-cars-selector/tool-cars-selector.component';
import { AlarmPageComponent } from './alarms/page/locations-alarms/alarmPage.component';
import { PanelExternalLayersComponent } from './locations-map/components/panel-external-layers/panel-external-layers.component';
import { RolePageComponent } from './roles/page/rolePage.component';
import { RolesAddComponent } from './roles/components/roles-add/roles-add.component';
import { RolesUpdateComponent } from './roles/components/roles-update/roles-update.component';
import {MatExpansionModule} from '@angular/material/expansion';
import { PermissionFilterPipe } from './shared/pipes/Permission-filter.pipe';
import { FindUrlPipe } from './shared/pipes/FindUrlPipe.pipe';
import { FilterOptionsFromArray } from './shared/pipes/FilterOptionsFromArray.pipe';
import { UnifiedMapComponent } from './unified-map/unified-map.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { ErrorPageComponent } from './shared/features/error-page/page/error-page.component';
import { UserLogsPageComponent } from './users/pages/user-logsPage/user-logsPage.component';
import { CustomerControlComponent } from './users/components/customer-control/customer-control.component';
import { CarDetailsComponent } from './locations-map/components/panel-detail-locations/categories-details-panels/car-details/car-details.component';
import { EngineerDetailsComponent } from './locations-map/components/panel-detail-locations/categories-details-panels/engineer-details/engineer-details.component';
import { ServiceDetailsComponent } from './locations-map/components/panel-detail-locations/categories-details-panels/service-details/service-details.component';
import { GenericLocationDetailsComponent } from './locations-map/components/panel-detail-locations/categories-details-panels/generic-location-details/generic-location-details.component';
import { GenericVirtualLocationDetailsComponent } from './locations-map/components/panel-detail-locations/categories-details-panels/generic-virtual-location-details/generic-virtual-location-details.component';
import { LocationRelatedListComponent } from './locations-map/components/panel-detail-locations/location-related/location-related-list/location-related-list.component.component';
import { LocationRelatedTicketPopupComponent } from './locations-map/components/panel-detail-locations/location-related/location-related-ticket-popup/location-related-ticket-popup.component';
import { ValetParkingMapComponent } from './locations-map/components/valet-parking-map/valet-parking-map.component';
import { SearchBarComponent } from './locations-map/components/search-bar/search-bar.component';
import { LocationButtonToolbarComponent } from './shared/features/location-button-toolbar/components/location-button-toolbar.component';
import { ActiveAlarmsPopupComponent } from './alarms/components/active-alarms-popup/active-alarms-popup.component';
import { ValetParkingService } from './locations-map/services/ValetParking.service';
import { CarouselComponent } from './shared/features/carousel/components/carousel/carousel.component';
import { CarouselPopupComponent } from './shared/features/carousel/components/carousel-popup/carousel-popup.component';
import { SystemNotificationComponent } from './shared/features/system-notification/components/system-notification.component';
import { NotificationPageComponent } from './notifications/page/notificationPage.component';
import { ActionsComponent } from './alarms/components/actions/actions.component';
import { GeneralLocationsDetailsPopUpComponent } from './locations-map/components/panel-detail-locations/location-popup-details/general-location-detail-popup/general-location-details-popup.component';
import { PanelMapLayersComponent } from './locations-map/components/panel-map-layers/panel-map-layers/panel-map-layers.component';
import { EiChatBotComponent } from './shared/features/azure-bot/components/ei-chat-bot/ei-chat-bot.component';
import { SystemAlarmsPageComponent } from './alarms/page/system-alarms/system-alarmsPage.component';
import { ActiveAlarmsListComponent } from './alarms/components/active-alarms-list/active-alarms-list.component';
import { UsersAddComponent } from './users/components/users-add/users-add.component';
import { RecurrentPlacesComponent } from './locations-map/components/recurrent-places/recurrent-places.component';
import { NgChartsModule } from 'ng2-charts';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { PopupDetailGeoposComponent } from './routeMap/components/popup-detail-geopos/popup-detail-geopos.component';
import { CallbackPageComponent } from './callback/page/callbackPage.component';
import { NavNotificationsComponent } from './notifications/components/nav-notifications/nav-notifications.component';
import { RouteSheetComponent } from './locations-map/components/panel-detail-locations/route-sheet/route-sheet/route-sheet.component';
import { RouteSheetListComponent } from './locations-map/components/panel-detail-locations/route-sheet/route-sheet-list/route-sheet-list.component';
import { GeneratedLayersComponent } from './locations-map/components/panel-internal-layers/generated-layers/generated-layers/generated-layers.component';
import { NameToSingularPipe } from './shared/pipes/NameToSingular.pipe';
import { RouteSheetServicesCardComponent } from './locations-map/components/panel-detail-locations/route-sheet/route-sheet-card/services-card/services-card.component';
import { RouteSheetGenericCardComponent } from './locations-map/components/panel-detail-locations/route-sheet/route-sheet-card/generic-card/generic-card.component';
import { UnitCardComponent } from './locations-map/components/panel-detail-locations/route-sheet/route-sheet-card/unit-card/unit-card.component';
import { ServiceLocationDetailPopupComponent } from './locations-map/components/panel-detail-locations/location-popup-details/service-location-detail-popup/service-location-detail-popup.component';
import { LocationsLocationDetailPopupComponent } from './locations-map/components/panel-detail-locations/location-popup-details/locations-location-detail-popup/locations-location-detail-popup.component';
import { ReplaceIconPanel } from './shared/pipes/ReplaceIconPanel.pipe';
import { RolesListComponent } from './roles/components/roles-list/roles-list.component';
import { UserLogsListComponent } from './users/components/user-logs-list/user-logs-list.component';
import { SystemAlarmsListComponent } from './alarms/components/system-alarms-list/system-alarms-list.component';
import { SettingsPageComponent } from './dashboard-admin/settings-page/settings-page.component';
import { SettingsMenuComponent } from './dashboard-admin/components/settings-menu/settings-menu.component';
import { ToolStreetInfoBoxComponent } from './locations-map/components/tools/tool-street-info-box/tool-street-info-box.component';
import { DownloadsComponent } from './download-center/page/downloads/downloads.component';
import { DownloadsListComponent } from './download-center/components/downloads-list/downloads-list.component';
import { DownloadsTableComponent } from './download-center/components/downloads-table/downloads-table.component';
import { MainDashboardPageComponent } from './main-dashboard/page/main-dashboard-page/main-dashboard-page.component';
import { UserCardComponent } from './main-dashboard/components/user-card/user-card.component';
import { LocationsCardComponent } from './main-dashboard/components/locations-card/locations-card.component';
import { RequestsCardComponent } from './main-dashboard/components/requests-card/requests-card.component';
import { AlertsCardComponent } from './main-dashboard/components/alerts-card/alerts-card.component';
import { MatChipsModule } from '@angular/material/chips';
import { PanelEditGeofencesComponent } from './geofences-map/components/panel-edit-geofences/main-panel/panel-edit-geofences.component';
import { ZoneSelectorComponent } from './geofences-map/components/panel-edit-geofences/zone-selector/zone-selector.component';
import { BufferSelectorComponent } from './geofences-map/components/panel-edit-geofences/buffer-selector/buffer-selector.component';
import { PolygonSelectorComponent } from './geofences-map/components/panel-edit-geofences/polygon-selector/polygon-selector.component';
import { AlarmTableComponent } from './alarms/components/alarm-table/alarm-table.component';
import { AlarmChartComponent } from './main-dashboard/components/alarm-chart/alarm-chart.component';
import { ScreenBlockerComponent } from './shared/features/screen-blocker/components/screen-blocker/screen-blocker.component';
@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    MapComponent,
    Map2Component,
    Map3Component,
    PinBarComponent,
    PopupDetailGeoposComponent,
    PanelLocationsComponent,
    PanelInternalLayersComponent,
    PanelExternalLayersComponent,
    PageNotFoundComponent,
    LoginPageComponent,
    ConfigurationsPageComponent,
    UserPageComponent,
    TableListComponent,
    SearchComponent,
    TableFiltersComponent,
    LoadingComponent,
    TooltipComponent,
    DashboardPageComponent,
    RouteMapComponent,
    RouteFilterComponent,
    LocationsMapComponent,
    FilterPipe,
    BasemapSelectorComponent,
    PanelDetailLocationsComponent,
    PanelResumeRouteComponent,
    PanelDetailRouteStepsComponent,
    GeofencesMapComponent,
    PanelGeofencesComponent,
    TableauReportComponent,
    PanelDetailGeofencesComponent,
    PanelEditGeofencesComponent,
    NavHeaderComponent,
    FilterMapComponent,
    FilterMapAutocompleteComponent,
    ConfirmDialogComponent,
    ReportListComponent,
    MessageDialogComponent,
    UsersListComponent,
    GenericTableComponent,
    UsersAddComponent,
    UsersUpdateComponent,
    PopupReportHistorialComponent,
    RecoveryPasswordDialogComponent,
    RecoveryPasswordPageComponent,
    SendRecoveryPasswordDialogComponent,
    EmailSendDialogComponent,
    AdminVinControlComponent,
    CallbackPageComponent,
    ToolCarsSelectorComponent,
    AlarmPageComponent,
    RolePageComponent,
    RolesAddComponent,
    RolesUpdateComponent,
    PermissionFilterPipe,
    FindUrlPipe,
    FilterOptionsFromArray,
    UnifiedMapComponent,
    RecoveryPasswordDialogComponent, MessageDialogComponent, SendRecoveryPasswordDialogComponent, EmailSendDialogComponent,
    ErrorPageComponent,
    CustomerControlComponent,
    UserLogsPageComponent,
    CarDetailsComponent,
    EngineerDetailsComponent,
    ServiceDetailsComponent,
    GenericLocationDetailsComponent,
    GenericVirtualLocationDetailsComponent,
    LocationRelatedListComponent,
    LocationRelatedTicketPopupComponent,
    ValetParkingMapComponent,
    SearchBarComponent,
    LocationButtonToolbarComponent,
    ActiveAlarmsListComponent,
    ActiveAlarmsPopupComponent,
    CarouselComponent,
    CarouselPopupComponent,
    SystemNotificationComponent,
    NotificationPageComponent,
    ActionsComponent,
    GeneralLocationsDetailsPopUpComponent,
    PanelMapLayersComponent,
    EiChatBotComponent,
    SystemAlarmsPageComponent,
    RecurrentPlacesComponent,
    NavNotificationsComponent,
    RouteSheetComponent,
    RouteSheetListComponent,
    GeneratedLayersComponent,
    RouteSheetServicesCardComponent,
    RouteSheetGenericCardComponent,
    UnitCardComponent,
    ServiceLocationDetailPopupComponent,
    LocationsLocationDetailPopupComponent,
    NameToSingularPipe,
    ReplaceIconPanel,
    RolesListComponent,
    UserLogsListComponent,
    SystemAlarmsListComponent,
    SettingsPageComponent,
    SettingsMenuComponent,
    ToolStreetInfoBoxComponent,
    DownloadsComponent,
    DownloadsListComponent,
    DownloadsTableComponent,
    MainDashboardPageComponent,
    UserCardComponent,
    LocationsCardComponent,
    RequestsCardComponent,
    AlertsCardComponent,
    AlarmTableComponent,
    ZoneSelectorComponent,
    BufferSelectorComponent,
    PolygonSelectorComponent,
    AlarmChartComponent,
    ScreenBlockerComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: "ng-cli-universal" }),
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatExpansionModule,
    ToastrModule.forRoot({
      timeOut: 2000,
    }),
    CommonModule,
   
    JwtModule,
    MaterialModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    HttpClientModule,
    ToastrModule,
    BrowserAnimationsModule,
    NgChartsModule,
    NgxSkeletonLoaderModule,
    MatChipsModule,
    // ApiAuthorizationModule,
    
    RouterModule.forRoot(
      [
        { path: "", redirectTo: "/home", pathMatch: "full" },
        { path: "home", component: HomeComponent },
        { path: "login", component: LoginPageComponent },
        { path: "logout", component: LogoutComponent },
        { path: "users", component: UserPageComponent },
        { path: "users/add", component: UsersAddComponent },
        { path: "users/update", component: UsersUpdateComponent },
        { path: "roles", component: RolePageComponent },
        { path: "roles/add", component: RolesAddComponent },
        { path: "roles/update", component: RolesUpdateComponent },
        { path: "roles", component: RolePageComponent },
        { path: "userLogs", component: UserLogsPageComponent },
        { path: "locationsMap", component: LocationsMapComponent },
        { path: "routingMap", component: RouteMapComponent },
        { path: "geofencesMap", component: GeofencesMapComponent },
        { path: "alarms", component: AlarmPageComponent },
        { path: "systemAlarms", component: SystemAlarmsPageComponent },
        { path: "notifications", component: NotificationPageComponent },
        { path: 'recoveryPassword/:key', component: RecoveryPasswordPageComponent},
        { path: "dashboardAdmin", component: ConfigurationsPageComponent },
        { path: "settingsAdmin", component: SettingsPageComponent },
        { path: "dashboard", component: DashboardPageComponent },
        { path: "callback", component: CallbackPageComponent },
        { path: "unifiedMap", component: UnifiedMapComponent },
        { path: "error", component: ErrorPageComponent },
        { path: "downloads", component: DownloadsComponent },
        { path: "mainDashboard", component: MainDashboardPageComponent },
        // { path: "**", component: PageNotFoundComponent },
        // { path: 'fetch-data', component: FetchDataComponent, canActivate: [AuthorizeGuard] },
      ],
      { useHash: true, onSameUrlNavigation: "reload" }
    ),
  ],
  exports: [],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    {
      provide: JWT_OPTIONS,
      useValue: JWT_OPTIONS,
    },
    JwtHelperService,
    SignalRService,
    MapHelperService,
    ValetParkingService,
    NameToSingularPipe,
    PermissionFilterPipe,
    ReplaceIconPanel,
    {provide: MAT_DATE_LOCALE, useValue: 'es-ES'}
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    iconRegistry.addSvgIcon(
      'custom_calendar',
      sanitizer.bypassSecurityTrustResourceUrl('assets/img/icon_calendario.svg')
    );
  }
}
